<div class="row mt-5 justify-content-center">
    <div class="col-lg-8 col-md-10 col-sm-12">
        <div class="text-start">
            <h4 *ngIf="!showSuccess" class="text-primary mb-3">Recuperación de contraseña</h4>
        </div>
        <form #forgotPasswordForm="ngForm" novalidate (ngSubmit)="onSubmit(forgotPasswordForm)" *ngIf="!showSuccess">
            <div class="row mb-3">
                <div class="col">
                    <label class=" control-label mb-0" for="email">Usuario</label>
                    <p class="m-0 text-primary font-weight-bold">{{passwordReset.username}}</p>
                </div>
            </div>
            <div class="form-floating mb-3">
                <input class="form-control" name="password" id="password" #password="ngModel" type="password" [(ngModel)]="passwordReset.password" autocomplete="off" placeholder="-" required />
                <label class="control-label " for="password">Nueva Contraseña</label>
                <app-error class="invalid-feedback" [errors]="password.errors"></app-error>
            </div>
            <div class="form-floating mb-3">
                <input class="form-control" name="confirmPassword" equal-value [validationError]="'Las contraseñas tienen que ser iguales'" [valueToCompare]="passwordReset.password" #confirmPassword="ngModel" id="confirmPassword" type="password" [(ngModel)]="passwordReset.confirmPassword"
                    autocomplete="off" placeholder="-" required />
                <label class="control-label" for="confirmPassword">Confirmar contraseña</label>
                <app-error class="invalid-feedback" [errors]="confirmPassword.errors"></app-error>
            </div>
            <div *ngIf="invalidToken">
                <div class="alert alert-danger fade show">
                    {{invalidTokenMessage}} <a class="alert-link" [routerLink]="['/forgot-password']">Volver a generar código</a>
                </div>
            </div>
            <div class="form-row  mt-5">
                <div class="col text-right d-flex flex-column">
                    <button type="submit" [disabled]="formSubmitted" class="btn btn-primary py-3 btn-block">Confirmar</button>
                    <button type="button" class="btn btn-link  btn-sm btn-block" [routerLink]="['/login']">Atrás</button>
                </div>
            </div>
        </form>
        <div *ngIf="showSuccess">
            <div class="row my-3">
                <div class="col">
                    <h5 class="text-success">¡Listo!</h5>
                    <p class="text-secondary">Tu contraseña ha sido actualizada. Que gusto tenerte de vuelta.</p>
                </div>
            </div>
            <div class="row">
                <div class="col text-right">
                    <button type="button" class="btn btn-primary btn-block" [routerLink]="['/login']">Iniciar sesión</button>
                </div>
            </div>
        </div>
    </div>
</div>